import BlockPadding from '@/components/block-padding';
import common from '@/components/lexemes/common';
import { Button, Header2, P1 } from '@bumble/ui-kit';
import { useRouter } from 'next/router';

import Thumbnail from '../thumbnail';
import styles from './related-stories.module.scss';

export default function RelatedStories({ data }: { data: any }) {
  const router = useRouter();

  const { title, description, relatedStories, buttonText = 'View more stories' } = data || {};

  return (
    <div className={styles.related__stories}>
      <BlockPadding>
        <div className={styles.copy}>
          <Header2>{title}</Header2>
          <P1>{description}</P1>
        </div>

        <div className={styles.stories}>
          {relatedStories?.map((story: any, index: number) => {
            console.log(story);
            return (
              <Thumbnail
                key={index}
                title={story?.title}
                excerpt={story?.excerpt}
                secondaryInfo={story?.secondaryInfo}
                image={story?.cardImage}
                slug={story?.slug}
                metIn={story?.metIn}
                buttonText={common.lxReadMore()}
              />
            );
          })}
        </div>

        <div className={styles.button}>
          <Button text={buttonText} href={`/love-stories/${router.locale}/stories`} />
        </div>
      </BlockPadding>
    </div>
  );
}
